<template>
  <div v-if="frame" class="simple-text-form" v-on:click.stop v-on:mouseleave.stop>
    <div v-if="!submitted" class="tag-content">
      <h3 class="title">
        {{ meta.title }}
      </h3>
      <textarea placeholder="type here..." v-model="textValue" rows="3" />
      <button class="button submit" @click="submit">SUBMIT</button>
    </div>
  </div>
</template>
<script>

import { isInScormLMS, setScore, setSessionTime, setLessonLocation } from './scormintegration'
import { analytics } from './mixins/analytics/'

export default {
  name: 'simpleTextForm',
  props: ['meta', 'frame', 'isLastFrame'],
  mixins: [analytics],
  watch: {
    isLastFrame(value) {
      if (value) {
        this.$emit('show')
        this.videoElement.pause()
      }
    },
    'meta': 'initTag'
  },
  data() {
    // const answers = this.quiz.isSortable ? this.shuffle(this.quiz.answers) : this.quiz.answers
    // const values = new Array(this.quiz.answers.length)
    return {
      submitted: false,
      textValue: '',
      videoElement: null
    }
  },
  computed: {
  },
  created() {
    this.$nextTick(() => {
      this.videoElement = document.getElementsByClassName('viewer-video')[0]
    })
    console.log('simpleTextForm created', this.textfrom)
    this.sessionStartTime = (new Date()).getTime()
    this.initTag()
  },
  directives: {
  },
  methods: {
    initTag() {
      console.log('simpleTextForm.inited', this.$vnode.tag)
    },
    submit() {
      console.log('submit')
      this.storeScore(1)
      // reset submitted for now, for repeated use
      this.submitted = false
      this.$emit('hide')
      this.videoElement.play()
      this.trackEvent('Simple Text Entry', this.meta.title, this.textValue)
    },
    storeScore(score, passed) {
      // scorm score integration
      try {
        var inLMS = isInScormLMS()
        console.log('is in LMS', inLMS)
        if (inLMS) {
          // initialize scorm data
          setScore(score)
          var now = (new Date()).getTime()
          setSessionTime(now - this.sessionStartTime)
          setLessonLocation(this.quiz.question)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}

</script>
